import "./module/userAgentChecker.min.js"
import "./module/plugin.js"

import ModalVideo from 'modal-video';
new ModalVideo('.js-modal-video', {channel: 'video'});

require('picturefill');